import React, { useState, useEffect } from 'react';
import { connect } from "react-redux";
import withSizes from 'react-sizes';
import Prismic from '@prismicio/client';

import { Col } from "deltoid/core/Blocks/BootstrapContainers";

import PayUWhiteIcon from "../../../assets/svgs/PayU-white-icon.svg";
import PayUIcon from "../../../assets/svgs/PayU-Icon.svg";
import LoginIllustration from "../../../assets/svgs/loginIllustration.svg";
import config from '../../../shared/services/config';
import OAuthCMS from './OAuthCMS';

const SignUpCMS = (props) => {
  const apiEndPoint = config.get('prismicCmsHost');
  const accessToken = config.get('cmsAccessToken');
  const Client = Prismic.client(apiEndPoint, { accessToken })
  const [doc, setDocData] = useState(null);
  const [resellerId, setResllerId] = useState(null);

  const fetchData = async () => {
    let UIDs = [config.get('PRISMIC_DEFAULT_SIGNUP_DOC_ID')];
    if (config.get('campaign_context'))
      UIDs = [config.get('campaign_context'), ...UIDs]
    const response = await Client.query(Prismic.Predicates.in('my.signup.uid', UIDs))
    if (response) {
      setDocData(response.results[0].data)
    }
  }

  useEffect(() => {
    fetchData()
    const queryString = window.sessionStorage.getItem('queryString');
    const urlParams = new URLSearchParams(queryString);
    const reseller_id = urlParams.get('reseller_id');
    setResllerId(reseller_id);
  }, []);

  const onMoreClick = () => {
    window.open(doc.link.url, "_blank");
  }

  const onLogoClick = () => {
    if (config.get('product') === 'PARTNER') {
      window.open(`${process.env.PARTNER_HOST}`, "_blank");
    }
    else {
      window.open(`${process.env.PAYU_WEBSITE_HOST}`, "_blank");
    }
  }

  const getMobileContent = () => {
    return (
      <Col md={12} className='p-0 d-flex justify-content-between grey-background login-illustration'>
        <a onClick={onLogoClick} className='pt-4 px-4'>
          <img src={config.get('PAYU_LOGO_IMG_URL')} height={40} className='w-auto' />
        </a>
        <LoginIllustration />
      </Col>
    )
  }

  const getWebContent = () => {
    return (
      <div className='cms-content'>
        {
          doc && (
            <div className='pl-5 pt-4 vh-100' style={{
              backgroundImage: `url(${doc.backgroundimage.url})`,
              backgroundSize: "cover",
            }
            }>
              <a onClick={onLogoClick}>
                <img src={config.get('PAYU_WHITE_LOGO_IMG_URL')} height={40} className='w-auto' />
              </a>
              <div className='event-details px-4'>
                <button>EVENT UPDATE</button>
                <h1 className='font-weight-bold'>{doc.heading[0].text}</h1>
                <h6 className="pt-2 pb-3">{doc.description[0].text}</h6>
                <a onClick={onMoreClick} >MORE DETAILS {">"}</a>
              </div>
            </div>
          )
        }
      </div>
    )
  }

  return (
    <>
      {
        resellerId ? <OAuthCMS />
          :
          <>
            {props.isMobile ? getMobileContent() : getWebContent()}
          </>
      }
    </>
  )
}

const mapSizesToProps = ({ width }) => ({
  isMobile: width < 768,
});


const mapDispatchToProps = (dispatch) => ({
  dispatch,
});

const Responsive = withSizes(mapSizesToProps)(SignUpCMS);

export default connect(null, mapDispatchToProps)(Responsive);